export default "/fonts/iu.ttf?271e64246d9be5b0201735e439c39a57";